import { matchPath } from 'react-router-dom';
import { MenuItemType } from 'types';

export const buildBreadcrumbTrail = (menuItems: MenuItemType[], path: string): MenuItemType[] => {
  let bestTrail: MenuItemType[] = [];
  let bestScore = -1;

  const evaluateMatch = (itemPath: string, currentPath: string): number | null => {
    const isExactMatch = matchPath({ path: itemPath, end: true }, currentPath);
    if (isExactMatch) {
      return 10000 + itemPath.length;
    }

    const isPrefixMatch = matchPath({ path: itemPath, end: false }, currentPath);
    if (isPrefixMatch) {
      return itemPath.length;
    }

    return null;
  };

  const findTrail = (items: MenuItemType[], currentTrail: MenuItemType[] = []) => {
    for (const item of items) {
      const nextTrail = [...currentTrail, item];

      if (item.path) {
        const matchScore = evaluateMatch(item.path, path);

        if (matchScore !== null) {
          const scoreWithDepth = matchScore + nextTrail.length / 1000;
          if (scoreWithDepth > bestScore) {
            bestScore = scoreWithDepth;
            bestTrail = nextTrail;
          }
        }
      }

      if (item.children?.length) {
        findTrail(item.children, nextTrail);
      }
    }
  };

  findTrail(menuItems);
  return bestTrail;
};
